import { render, staticRenderFns } from "./Unfollow.vue?vue&type=template&id=0f393364"
import script from "./Unfollow.vue?vue&type=script&lang=js"
export * from "./Unfollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports